<template>
  <div class="w-full">
    <div class="hidden items-baseline justify-start gap-x-2 sm:flex">
      <Headline tag="h1" size="2xl" :is-uppercase="false">
        {{ $t('basket.heading') }}
      </Headline>
      <div class="text-base text-gray-secondary">
        {{ count }}
        {{ $t('basket.products_count', count) }}
      </div>
    </div>
    <div>
      <p>{{ $t('basket.no_items_info') }}</p>
      <p>{{ $t('basket.continue_shopping_info') }}</p>
    </div>
    <div class="mt-10 flex space-x-4">
      <LinkAsButton :to="toLocalePath('/')" type="tertiary">
        {{ $t('basket.continue_shopping_label') }}
      </LinkAsButton>
      <LinkAsButton v-if="!isLoggedIn" :to="toLocalePath({ name: 'signin' })">
        {{ $t('basket.sign_in_label') }}
      </LinkAsButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import useAgsUser from '../../composables/useAgsUser'
import useRouteHelpers from '../../composables/useRouteHelpers'

defineProps<{ count: number }>()

const { isLoggedIn } = useAgsUser()
const { toLocalePath } = useRouteHelpers()
</script>
